export const CAMERA_CONFIG = {
  fov: 45,
  position: [0, 33, 101],
};

export const CAMERA_OFFSETS = {
  x: -1,
  y: 4,
  z: 18,
};

export const CAMERA_ROTATION_POSITION_OFFSETS = {
  middle: {
    position: {
      x: 4,
      y: 0,
      z: 0,
    },
    rotation: {
      x: 0,
      y: 0,
      z: 0,
    },
  },
  left: {
    position: {
      x: 4,
      y: 0,
      z: 0,
    },
    rotation: {
      x: 0,
      y: 0.34,
      z: 0,
    },
  },
  right: {
    position: {
      x: 4,
      y: 0,
      z: 0,
    },
    rotation: {
      x: 0,
      y: -0.34,
      z: 0,
    },
  },
};
